var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import CryptoJS from "crypto-js";
import Cookies from "universal-cookie";
var cookies = new Cookies();
var cookieSteup = function (props) {
    var WriteCookie = function (_a, data, otherOptions) {
        var name = _a.name, key = _a.key;
        try {
            var encriptedData = CryptoJS.AES.encrypt(JSON.stringify(data), key).toString();
            cookies.set(name, encriptedData, __assign(__assign({}, props.options), otherOptions));
            return true;
        }
        catch (error) {
            return false;
        }
    };
    var ReadCookie = function (_a) {
        var name = _a.name, key = _a.key;
        try {
            var lsData = cookies.get(name);
            if (lsData) {
                var bytes = CryptoJS.AES.decrypt(lsData, key);
                return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            }
            else {
                return false;
            }
        }
        catch (error) {
            return false;
        }
    };
    var RemoveCookie = function (_a, otherOptions) {
        var name = _a.name;
        try {
            cookies.remove(name, __assign(__assign({}, props.options), otherOptions));
            return true;
        }
        catch (error) {
            return false;
        }
    };
    return { WriteCookie: WriteCookie, ReadCookie: ReadCookie, RemoveCookie: RemoveCookie };
};
export { cookieSteup };
